import template from './commercial-building-type.jade';
import buildingTypeOptions from './../../../enums/commercial-building-type';

export default angular
  .module('cian.addForm.commercialBuildingType', [])
  .directive('cianAfAboutBuildingCommercialBuildingType', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = buildingTypeOptions;
    },
    controllerAs: 'commercialBuildingType',
    template,
  })).name;
